import { escapeRegExp } from 'lodash';
import React from 'react';
import { DATE_FORMAT_URL } from '../../../../data/constants/datetime';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import { useSidePanel } from '../../../../data/hooks/ui/useSidePanel';
import { eventMomentFactory } from '../../../../data/misc/eventMomentFactory';
import Icon from '../../../elements/icons/Icon';
import Link from '../../../elements/Link';

const LiveVotingButton = (props) => {
    const { event, programItem, votingSession } = props,
        i18n = useI18n(),
        votingPath = ['/events', event.id, 'schedule', eventMomentFactory(event, programItem.start_local).format(DATE_FORMAT_URL), programItem.id, 'livevoting', votingSession?.id].join('/'),
        fullScreen = useSidePanel().maximize,
        votingPathExpr = new RegExp(escapeRegExp(`/livevoting/${votingSession?.id}`) + '$'),
        isVotingScreenOpen = app.history.location.pathname.match(votingPathExpr),
        isButtonActive = votingSession?.is_open && isVotingScreenOpen && !fullScreen;

    function handleOpenLiveVoting() {
        app.store.dispatch(app.actions.ui.sidePanel.maximize(false));
    }

    if (!votingSession?.is_open) return null;

    return (
        <Link className={isButtonActive ? 'is-active' : ''} href={votingPath} onClick={handleOpenLiveVoting}>
            <Icon src={'img/vote_icon.png'} size={22} />
            {event.settings.vote_label || i18n['label.vote']}
        </Link>
    );
};

export default LiveVotingButton;
